import { searchPharmacyMedicinesApi } from "../../../services/pharmacyMedicines.services";

/**
 * Medicine lookup for the ordering flows, excluding inactive medicines.
 *
 * The filter is applied twice on purpose: `is_active=true` asks the API to do
 * it, and the client-side filter covers the case where the endpoint ignores the
 * parameter. If the payload has no `is_active` field at all, neither takes
 * effect and the backend needs to expose it.
 */
export const fetchActivePharmacyMedicines = (text) =>
  searchPharmacyMedicinesApi(
    `query=${encodeURIComponent(String(text || "").toLowerCase())}&is_active=true`
  ).then((res) =>
    (res?.data || [])
      .filter((item) => item?.is_active !== false)
      .map((item) => ({
        value: item.record_id,
        label: item.name,
        /*
         * Read by AsyncSearchSelect to badge the row Available / Out of Stock.
         *
         * Everything this endpoint returns is a pharmacy medicine, but the
         * payload carries no `is_pharmacy_medicine` of its own - so the flag
         * arrived undefined and MedicineStockTag, which bails without it,
         * drew no badge at all. Two catalogue rows that share a name then
         * read as the same medicine listed twice, with nothing to say which
         * one holds the stock. The flag is asserted here and only here, so a
         * caller that genuinely mixes in org medicines is unaffected.
         */
        is_pharmacy_medicine: item.is_pharmacy_medicine ?? true,
        current_stock: item.current_stock,
      }))
  );

export default fetchActivePharmacyMedicines;
